import { FORM_ROW, FORM_ERROR, FORM_ERROR_MSG_CLASS } from '../../config';
import { querySelector, querySelectorAll } from '../../functions/querySelectors';

let hideOldErrors = function(form) {
  let errors = querySelectorAll(`.${FORM_ERROR}`, form);

  errors.forEach((error) => {
    error.classList.remove(FORM_ERROR);
  });
};

export function showFormErrors(form, errors) {
  let focused = false;

  hideOldErrors(form);

  for (var i = 0; i < errors.length; i++) {
    let elem = errors[i].element;
    let message = errors[i].message;

    let row = elem.closest(`.${FORM_ROW}`);

    if (row) {
      row.classList.add(FORM_ERROR);

      let msg = querySelector(`.${FORM_ERROR_MSG_CLASS}`, row);

      if (!msg) {
        msg = document.createElement('span');
        msg.classList.add(FORM_ERROR_MSG_CLASS);
        row.appendChild(msg);
      }

      msg.textContent = message;
    }

    if (!focused && elem.focus) {
      elem.focus();
      focused = true;
    }
  }
}
